const guestSnapshotCacheName = 'tov-plus-guest-snapshots-v1';

export async function writeGuestSnapshot<T>(key: string, value: T) {
  if (typeof window === 'undefined' || !('caches' in window)) {
    return;
  }

  const cache = await window.caches.open(guestSnapshotCacheName);
  await cache.put(
    new Request(`https://guest-cache.local/${encodeURIComponent(key)}`),
    new Response(JSON.stringify(value), {
      headers: {
        'content-type': 'application/json',
      },
    }),
  );
}

export async function readGuestSnapshot<T>(key: string): Promise<T | null> {
  if (typeof window === 'undefined' || !('caches' in window)) {
    return null;
  }

  const cache = await window.caches.open(guestSnapshotCacheName);
  const response = await cache.match(
    new Request(`https://guest-cache.local/${encodeURIComponent(key)}`),
  );

  if (!response) {
    return null;
  }

  try {
    return (await response.json()) as T;
  } catch {
    return null;
  }
}
